var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoc00NAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.801,
    height: 21.998,
    viewBox: "0 0 21.801 21.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H21.8V22H0Z",
    transform: "translate(-3.323 -1.451)",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.323 1.451)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.212,6.3A5.8,5.8,0,1,1,9.407.5,5.8,5.8,0,0,1,15.212,6.3Z",
    transform: "translate(-2.227 1.177)",
    fill: "none",
    stroke: "#272727",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5,19.455a8.265,8.265,0,1,1,16.53,0",
    transform: "translate(-1.123 -2.036)",
    fill: "none",
    stroke: "#272727",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoc00NAccountIcon);
export default __webpack_public_path__ + "static/media/coc00n_account_icon.09e9ad353a719b5a73140f7443ed7360.svg";
export { ForwardRef as ReactComponent };